import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class KafkaWrapper extends DatabaseWrapper {

	constructor(database: Database) {
		super(database);
		this.dbTyp_Id = DatabaseEnum.kafka.ID;
		this.name = DatabaseEnum.kafka.NAME;
		this.code = DatabaseEnum.kafka.CODE;
		this.equivalentTag = DatabaseEnum.kafka.EQUIVALENT_TAG;
		this.showDatabaseTab = false;
		this.isFileType = true;
		this.showPropertiesTab = false;
    this.showDataDescription = false;

	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {

		if (repConnWrapper.repConn.conn.bootstrapServers == "") {
			repConnWrapper.inValid_Cds.push('BOOTSTRAP_SERVERS');
		}
		if (repConnWrapper.repConn.conn.topic == "") {
			repConnWrapper.inValid_Cds.push('TOPIC');
		}
		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}
	}

	///todo  flag as parameter
	getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(),isHiveNative: boolean = false): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
			this.attributeTabulator.getDistKeyFlag(objectWrapper),
			this.attributeTabulator.getOrgKeyFlag(objectWrapper),
			this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getPartitionflag(objectWrapper,isHiveNative),
			this.attributeTabulator.getAttrExprVal(objectWrapper, component),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		]
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isMax: boolean = false,component:any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getDistKeyFlag(objectWrapper),
			this.attributeTabulator.getOrgKeyFlag(objectWrapper),
			this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		]
	}
}
